import { render } from "./StudioDialog.vue?vue&type=template&id=73049452&scoped=true&ts=true"
import script from "./StudioDialog.vue?vue&type=script&lang=ts"
export * from "./StudioDialog.vue?vue&type=script&lang=ts"

import "./StudioDialog.vue?vue&type=style&index=0&id=73049452&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.42_vue@3.3.4_webpack@5.99.6_esbuild@0.25.3_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73049452"]])

export default __exports__